export default __webpack_public_path__ + "static/media/Sleightcraft Mitts.c51c1e29.jpg";